import type { OutreachOperation } from '@discovr/types';

/** The one stall message for every operation surface (approve-drafts, retry). */
export const OPERATION_STALL_COPY = 'Stopped unexpectedly — try again'; // copy: ours

/** Go's stall close can add a failed outcome (item key `_operation`) without
 *  counting it in failedCount, so the outcomes are counted too. */
export function failedTotal(operation: OutreachOperation): number {
  const listed = (operation.outcomes ?? []).filter((o) => o.outcome === 'failed').length;
  return Math.max(operation.failedCount, listed);
}
